import { RouteObject } from "react-router-dom";
import merchantsRouter from "./merchants/merchants-router";
import processorsRouter from "./processors/processors-router";
import transactionsRouter from "./transactions/transactions-router";
import dashboardRouter from "./dashboard/dashboard-router";
import reconciliationRouter from "./reconciliation/reconciliation-router";
import MerchantGuard from "./merchant-guard";
import AdminGuard from "./admin-guard";
import BanListPage from "./ban-list/ban-list-page";
import DefaultRoute from "./default-route";
// import PayerSetupPage from "./payer-setup.tsx/payer-setup-page";

const guardedProcessorsRouter = processorsRouter.map(route => ({
    ...route,
    element: (
        <MerchantGuard>
            {route.element}
        </MerchantGuard>
    )
}));

const guardedReconciliationRouter = reconciliationRouter.map(route => ({
    ...route,
    element: (
        <AdminGuard>
            {route.element}
        </AdminGuard>
    )
}));


const privateRouter: RouteObject[] = [
    {
        path: '',
        element: <DefaultRoute />,
    },
    {
        path: 'dashboard',
        children: dashboardRouter
    },
    {
        path: 'transactions',
        children: transactionsRouter
    },
    {
        path: 'merchants',
        children: merchantsRouter
    },

    {
        path: 'processors',
        children: guardedProcessorsRouter
    },
    {
        path: 'reconciliation',
        children: guardedReconciliationRouter
    },
    {
        path: 'ban-list',
        element:
            <AdminGuard>
                <BanListPage />
            </AdminGuard>
    }
]

export default privateRouter;